import { render } from "./Pcr.vue?vue&type=template&id=1f29490e&scoped=true"
import script from "./Pcr.vue?vue&type=script&lang=js"
export * from "./Pcr.vue?vue&type=script&lang=js"

import "./Pcr.vue?vue&type=style&index=0&id=1f29490e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f29490e"]])

export default __exports__